import type { SystemArchitectureDiagram } from "./systemArchitectureRegistry";

interface SystemArchitectureSupportingContentProps {
  diagram: SystemArchitectureDiagram;
}

export function SystemArchitectureReadingKey({
  diagram,
}: SystemArchitectureSupportingContentProps) {
  return (
    <aside
      aria-label="Diagram legend"
      className="system-architecture-route__reading-key"
      id="system-architecture-reading-key"
    >
      <strong>How to read</strong>
      <span className="system-architecture-route__legend-guidance">
        {diagram.readingKey}
      </span>
      <span className="system-architecture-route__legend-items">
        <span className="system-architecture-route__legend-item">
          <span
            aria-hidden="true"
            className="system-architecture-route__legend-arrow"
          >
            →
          </span>
          Direction of flow
        </span>
        <span className="system-architecture-route__legend-item">
          <span
            aria-hidden="true"
            className="system-architecture-route__legend-swatch system-architecture-route__legend-swatch--focus"
          />
          Main focus
        </span>
        {diagram.statusLabel ? (
          <span className="system-architecture-route__legend-item">
            <span
              aria-hidden="true"
              className="system-architecture-route__legend-swatch system-architecture-route__legend-swatch--inactive"
            />
            {diagram.statusLabel}
          </span>
        ) : null}
      </span>
    </aside>
  );
}

export function SystemArchitectureSupportingContent({
  diagram,
}: SystemArchitectureSupportingContentProps) {
  return (
    <>
      <div
        aria-label="Diagram summary"
        className="system-architecture-route__notes"
      >
        <section>
          <h3>What this shows</h3>
          <p>{diagram.textAlternative}</p>
        </section>
        <section>
          <h3>Use this to check</h3>
          <p>{diagram.testingFocus}</p>
        </section>
        <section>
          <h3>Limits of this view</h3>
          <p>{diagram.doesNotProve}</p>
        </section>
      </div>

      <div className="system-architecture-route__disclosures">
        <details>
          <summary>Technical notes</summary>
          <p>{diagram.technicalNote}</p>
        </details>
        <details>
          <summary>Sources used ({diagram.sources.length})</summary>
          <ul>
            {diagram.sources.map((source) => (
              <li key={source}>{source}</li>
            ))}
          </ul>
        </details>
        <details>
          <summary>
            Testing references ({diagram.testingSources.length})
          </summary>
          <ul>
            {diagram.testingSources.map((source) => (
              <li key={source}>{source}</li>
            ))}
          </ul>
        </details>
      </div>
    </>
  );
}
